import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

// P0 (2026-07-12): an API/render failure white-screened the operator mid-operation. This boundary catches any
// render crash and shows a recoverable screen instead of a blank page — the app degrades, never blanks.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || "Something went wrong." };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Ironclad ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-200 p-6"
      >
        <div className="max-w-md w-full rounded-xl border border-zinc-800 bg-zinc-900/70 p-6 text-center space-y-4">
          <AlertTriangle className="h-8 w-8 text-amber-400 mx-auto" />
          <h1 className="text-lg font-semibold">This screen hit a snag</h1>
          <p className="text-sm text-zinc-400">
            Your work is safe on the server. Reload to pick up where you left off — the bid engine keeps running
            in the background even if this screen reloads.
          </p>
          <p className="text-xs text-zinc-600 font-mono break-words">{this.state.message}</p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-zinc-950 hover:bg-amber-400 transition-colors"
          >
            <RotateCcw className="h-4 w-4" /> Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
